import React from "react";
import { ApiContext } from "@/contexts/ApiProvider";

export function useApi() {
  const context = React.useContext(ApiContext);

  if (!context) {
    throw new Error("useApi must be within ApiProvider");
  }

  return context;
}
